import { render } from "./CompletedOrders.vue?vue&type=template&id=73e7cd36&scoped=true"
import script from "./CompletedOrders.vue?vue&type=script&lang=js"
export * from "./CompletedOrders.vue?vue&type=script&lang=js"

import "./CompletedOrders.vue?vue&type=style&index=0&id=73e7cd36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e7cd36"]])

export default __exports__